export const BASE_URL = 'https://api-bgdz2ituxa-uc.a.run.app/'; //*****PRODUCCION****
//export const BASE_URL = "http://localhost:5000/app-epno/us-central1/api/"; 

//PRUEBAS QA
//export const BASE_URL = 'https://us-central1-app-epno-qa.cloudfunctions.net/api';

export const FIREBASE_URL = BASE_URL;

export const requestMethods = {
  GET: "GET",
  POST: "POST",
  HEAD: "HEAD",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
  CONNECT: "CONNECT",
};

export const API = {
  requestMethods: {
    GET: "GET",
    POST: "POST",

    HEAD: "HEAD",
    PUT: "PUT",
    PATCH: "PATCH",
    DELETE: "DELETE",
    CONNECT: "CONNECT",
  },
  CONEKTA: {
    REQUEST_PAYMENT: "payment/new",
  },
  ANALITICS: {
    SALES: "analitics/sales",
    SALES_PER_MONTH: "analitics/sales-by-category",
    PROJECT_SALES: "analitics/services-sales",
  },
  AUTH: {
    LOGIN_EPNO: "auth/login",
    LOGIN: "/api/self-service/sign-in",
    REGISTER: "auth/register",
    CHECK_SESSION: "/check-session",
    PASSWORD_RESET: "password-reset-request",
    PASSWORD_EMAIL: "password-reset",

    // EPNO ------------------------------------------------------------
    REGISTER_ADMIN: "auth/registerAdmin",
  },
  ORDERS_EXPRESS: {
    GET_ALL: "/orders-express/last",
  },
  ORDERS: {
    NEW: "orders/new",
    GET_BY_USER: "orders/user/",
    GET_BY_ID: "order/",
    GET_BY_CATEGORY: "orders/by-category?cat=",
    FILTER: "services/filter",
    ALL: "order/all",
    UPDATE: "order/update/",
    FINISHED: "services/finished",
    CANCELED: "services/canceled",
    QUOTE: "services/quote",
    BUILD: "services/build",
    TOGO: "services/togo",
    REVIEW: "services/review",
    APROVE: "services/aprove",
    ORDERS_EXPRESS: "/orders-express/new",

    APPLY: {
      NEW: "order/apply",
      UPDATE: "order-proposals/",
      DELETE: "order-proposals/",
      GET_ALL: "order-proposals",
      GET_BY_ORDER: "order-proposals/order/",
      GET_BY_SUP: "order-proposals/supplier/:supplier_id",
    },

    LOGS: {
      GET_BY_ORDER_ID: "order-logs/",
    },
  },
  SERVICES: {
    UPDATE: "services/update/",
    VIEW_SERVICES: "services/filter", //ver info de todos los servicios
    CANCEL: "services/cancel",
    UPDATE_BY_ID: "/service/update/:serviceId", //actualizar un servicio por id

    QUOTES: {
      APPLY: "service/apply",
      NEW_INTERNAL: "service/internal-apply",
      UPDATE: "service/proposal/",
      GET_BY_ORDER: "service/proposals/",
      CHOOSE_PROPOSAL: "/service/proposal/select/",
    },

    REVIEWS: {
      ADD: "services/review/",
      UPDATE: "services/review/",
      DELETE: "services/review/",
      REPLY: "services/review/reply/",
      GET: "services/reviews/",
    },

    COMPLAINTS: {
      NEW: "services/complaint",
      UPDATE: "services/complaint/",
      DELETE: "services/complaint/",
      REPLY: "/services/complaint/",
      GET: "/services/complaints/",
      SOLVE: "/services/complaint/",
    },
  },
  USER: {
    SUPPLIER: {
      GET_BY: "suppliers/",
      GET_ALL: "users/suppliers",
      GET_CATEGORIES: "/supplier/:id",
      UPDATE: "users/update", // Endpoint unificado
    },
    CHANGE_USER: "/api/self-service/change_user_vs",
    NEW_USER: "/api/self-service/create_new_user",
    NEW_USER_REQUEST: "/api/self-service/response_new_user_request",
    GET_USER_REQUEST: "/api/self-service/get_new_user_request",
    UPDOWN_USER: "/api/self-service/updown_user",
    USERS: "/api/self-service/get_all_users",
    ROLE: "/api/self-service/user_role",
    SOLICITUD_SOFTWARE: "/api/self-service/solicitudSoftware",
    ASSIGN_CLIENTS: "/users/assign",

    ASSIGN_CLIENTS: "users/assign",
    CLIENTS_ADMIN: "/users/clients-admin",

    // EPNO --------------------------------------------------------------
    GET_USER_BY_ID: "users/getById",
    GET_BY_ROLES: "/api/users/by-roles",
    ALL: "users/",
    UPDATE_STATUS: "users/updateStatus",
    SAVE_TOKEN: "users/save-token",
    CHANGE_LOGO: "users/update", // Apunta al mismo endpoint
    CHANGE_BANNER: "users/update", // Apunta al mismo endpoint
    CHANGE_LOGO: "users/update", // Apunta al mismo endpoint
    CHANGE_BANNER: "users/update", // Apunta al mismo endpoint
    GET_VS: "users/vs",
    UPLOAD_FISCAL: "users/upload-fiscal",
    DELETE: "users/",
    CLIENTS: "users/clients",
    CLIENTS_BY_BUYER: "users/clients-by-buyer/:buyerId",
    CLIENTS_BY_SELLER: "users/clients-by-seller/:sellerId",
    ASSIGNED_PERSONNEL: "users/assigned/:clientId",
    SELECTOR: "/users/selectors",
  },
  NOTIFICATIONS: {
    CHANGE_STATUS: "/api/self-service/change_notification_status",
    MARK_AS_READ: "/api/self-service/marcar_como_leido",
    GET_NOTIFICATION: "/api/self-service/get_notifications/1",
    GET_NOTIFICATIONS: "notifications/",
    NOTIFICATIONS_READ: "/notifications/:id/read",
    NOTIFICATIONS_READ_ALL: "/notifications/read-list",
  },
  CHAT: {
    NEW_ORDER: "chats/order/",
    NEW_QUOTE: "chats/service/",
    DESABLE_CHAT: "chats/service/",
    GET_BY_USER: "chats/user/",
    GET_ALL: "chats/admin/all",
    MESSAGE: "messages/",
    GET_MESSAGES_BY_CHAT: "messages/",
  },
  CUSTOMER: {
    ADD: "/api/self-service/perfilCustomer",
    CLIENT_CONSUME: "/api/self-service/gastos_perfil",
    PROFILE_CONSUME: "/api/self-service/gastos_perfilAdmin_client",
    CONSUME: "/api/self-service/consumo_cliente",
    EARNINGS: "/api/self-service/ganancias_client",
    EARNINGS_SUMMARY: "/api/self-service/ganancias_resumen_client",
  },
  MARKETING: {
    GET_ALL: "banners",
    GET_BY_ID: "banners/",
    ADD: "banners",
    UPDATE: "banners/",
    DELETE: "banners/",
  },
  VALUESTREAM: {
    VALUESTREAMS: "/api/self-service/get_vs",
  },
  MARKETPLACE: {
    CATEGORIES: {
      CREATE: "product-categories",
      GET_ALL: "product-categories",
      GET_SUBCATEGORIES: "product-categories",
      DELETE: "product-categories",
    },
    PRODUCTS: {
      NEW: "product/new",
      UPDATE: "product/update/",
      DELETE: "product/delete/",
      GET_ALL: "products",
      GET_BY_ID: "product/",
      GET_BY_CATEGORY: "products/filter?category=",
      GET_BY_CATEGORY_AND_SUBCATEGORY: "products?category=",
      GET_BY_SUPPLIER: "products/supplier/",
      SEARCH: "products?search=",
      FILTER: "/products/filter",
    },
    CART: {
      ADD_PRODUCT: "cart/add-product",
      UPDATE: "cart/",
      DELETE: "cart/",
      DELETE_PRODUCT: "cart/product/",
      GET_BY_ID: "cart/",
      GET_BY_CLIENT: "cart/client/",
      GET_ALL: "cart",
      CHECKOUT_3D_SECURE: "cart/checkout-3d-secure",
      THREE_D_SECURE_RESPONSE: "cart/3d-secure-response",
    },
    ORDERS: {
      NEW: "marketplace/orders/new",
      DELETE: "marketplace/orders/",
      UPDATE: "marketplace/orders/",
      GET_BY_ID: "marketplace/orders/",
      GET_BY_CLIENT: "marketplace/orders/client/",
      GET_ALL: "marketplace/orders",
      GET_BY_SUPPLIER: "marketplace/orders/supplier/",
    },
    LOGS: {
      GET_ALL: "marketplace/logs",
      GET_BY_ORDER: "marketplace/logs/",
    },
    VENDOR: {
      NEW: "marketplace/vendor",
      UPDATE: "marketplace/vendor/",
      ARCHIVE: "marketplace/vendor/archive/",
      UNARCHIVE: "marketplace/vendor/unarchive/",
      DELETE: "marketplace/vendor/",
      GET_ALL: "marketplace/vendors",
      GET_BY_USER: "marketplace/vendor/user/",
      GET_ALL_BY_USER: "marketplace/vendors/user/",
    },
    DHL: {
      QUOTE: "dhl/quote",
      CREATE_SHIPMENT: "dhl/shipments/create",
      TRACK_SHIPMENT: "dhl/shipments",
    },
  },
  SUPPLIERS: {
    CREATE: "supplier/create",
    LIST: "supplier/list",
    GET_BY: "supplier/",
    EDIT: "supplier/update/",
    DELETE: "supplier/delete/"


  },
  ACCOUNTS: {
    CREATE: "accounts/create",
    LIST: "accounts",
    GET_BY: "accounts/",
    EDIT: "accounts/update/",
    DELETE: "accounts/delete/"
  },

  EXPENSES: {
    CREATE: "expenses/create",
    LIST: "expenses",
    GET_BY: "expenses/",
    EDIT: "expenses/update/",
    DELETE: "expenses/"
  },

  FINANCIAL_DASHBOARD: {
    SUMMARY: "dashboard-financiero/summary",
    INDICATORS: "dashboard-financiero/indicators",
    ACCOUNTS: "dashboard-financiero/accounts",
    EXPENSES_REPORT: "dashboard-financiero/expenses-report",
    CALENDAR: "dashboard-financiero/calendar",
    CALENDAR_DAY: "dashboard-financiero/calendar/day",
  },
};
